import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICouponDayByDayDetails } from 'src/app/_interfaces/coupons/i-coupon-day-by-day-details';
import { ICouponDetails } from 'src/app/_interfaces/coupons/i-coupon-details';
import { ICouponTotalDetails } from 'src/app/_interfaces/coupons/i-coupon-total-details';
import { CouponsService } from 'src/app/_services/coupons.service';

@Component({
  selector: 'app-appointment-coupon-details',
  templateUrl: './appointment-coupon-details.component.html',
  styleUrls: ['./appointment-coupon-details.component.scss']
})
export class AppointmentCouponDetailsComponent implements OnInit {
  pageTitle: string = 'Coupons';
  couponId: number;
  couponDetails: ICouponDetails;
  basicDetails;
  eligibilityCriteria;
  usageSummary;
  dayByDayDetails;

  basicDetailsTH = [
    'Coutpon Type',
    'Coupon EN Name',
    'Coupon AR Name',
    'Coutpon Code',
    'Coutpon Start Time',
    'Coutpon End Time',
    'Coutpon Discount Percentage',
    'Coutpon Ceiling',
    'Coutpon Use'
  ];

  eligibilityCriteriaTH = [
    'DoctorType',
    'Specialty Name',
    'Doctor Name'
  ];

  dayByDayTH = [
    'Date',
    'Number of Coupons Used',
    'Number of Unique Patients',
    'Number of Paid Transactions',
    'Number of Unpaid Transactions',
    'Number of Finished Calls',
    'Number of Cancelled Calls',
    'Number of Not Completed Calls'
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private adminCouponsService: CouponsService
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.params.couponId;

    if (id) {
      this.couponId = id;
      this.getCouponDetails(this.couponId);
    }
  }

  getCouponDetails(couponId) {
    this.adminCouponsService
      .getCouponDetails(couponId)
      .subscribe((response) => {
        this.couponDetails = response.data
        this.basicDetails = this.couponDetails.basicDetails
        this.eligibilityCriteria = this.couponDetails.eligibilityAppotintmentCriteria
        this.usageSummary = this.couponDetails.usageSummary;
        this.dayByDayDetails = this.couponDetails.dayByDayAppointmentDetails
      });
  }
}

